import Typed from 'typed.js'

const typed = new Typed('#typed', {
	strings: [
		'',
		'^2000cat welcome.txt ^1400 <br> `Hey, I\'m Steve.<br>I love to build (and break) things on the web.``<br> <span class="prompt">→ <span class="cyan-term">v1.0</span> <span class="purple-term">git:</span><span class="purple-term">(</span><span class="red-term">main</span><span class="purple-term">)</span></span>&nbsp;`',
	],
	typeSpeed: 70,
	loop: false,
	startDelay: 0,
	cursorChar: '&#x258c;',
})
